module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder-editor-field', _vm._g({
    attrs: {
      "item": _vm.item,
      "show-required": true,
      "show-hide-in-form": true,
      "show-hide-in-reports": true,
      "show-hide-in-preview": true,
      "show-share-with-participant": true,
      "show-is-shared": true
    }
  }, _vm.$listeners), [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.item.name + '-buttontext'
    }
  }, [_vm._v("Button text")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.button),
      expression: "item.button"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-buttontext',
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.button)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "button", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de512b72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorImage.vue
// module id = 1746
// module chunks = 1